import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from "@angular/forms";
import { BrowserModule } from '@angular/platform-browser';
import { JobsComponent } from './jobs.component';
import {NewJobModule} from "../newJob/newJob.module";
import {ClipboardModule} from "ngx-clipboard";
import { SharedModule } from '../shared/shared.module';

@NgModule({
    imports: [CommonModule, BrowserModule, FormsModule, NewJobModule, ClipboardModule, SharedModule],
    declarations: [JobsComponent],
    exports: [JobsComponent]
})

export class JobsModule { }
